import { ReactNode } from 'react';
import { FormControlProps } from '@mui/material/FormControl';
import {
  MuiBox,
  MuiFormControl,
  MuiFormHelperText,
  MuiFormLabel,
} from '../../../../../modules/material';
import { StyledInlineLayout } from './styles';

export interface FormFieldWrapperProps extends FormControlProps {
  label?: ReactNode;
  helperText?: ReactNode;
  errorMessage?: ReactNode;
  inline?: boolean;
  testId?: string;
}

export default function FormFieldWrapper(props: FormFieldWrapperProps) {
  const {
    label,
    children,
    helperText,
    error,
    errorMessage,
    fullWidth = true,
    inline,
    testId = 'form-field-wrapper',
    ...formFieldWrapperProps
  } = props;

  const labelContent = label && <MuiFormLabel>{label}</MuiFormLabel>;
  const helperTextContent = helperText && (
    <MuiFormHelperText>{helperText}</MuiFormHelperText>
  );
  const errorMessageContent = error && errorMessage && (
    <MuiFormHelperText>{errorMessage}</MuiFormHelperText>
  );

  return (
    <MuiFormControl
      error={error}
      fullWidth={fullWidth}
      data-testid={testId}
      {...formFieldWrapperProps}
    >
      {inline ? (
        <>
          <StyledInlineLayout>
            {labelContent}
            {children}
          </StyledInlineLayout>
          {helperTextContent}
          {errorMessageContent}
        </>
      ) : (
        <>
          {(label || helperText) && (
            <MuiBox mb={1}>
              {labelContent}
              {helperTextContent}
            </MuiBox>
          )}
          {children}
          {errorMessageContent}
        </>
      )}
    </MuiFormControl>
  );
}
